import css from 'styled-jsx/css'
import { colors, fonts, fontSizes } from 'theme'

// TODO: Refactor - Create a badge component
export const iconStyles = css`
  :global(i.shoppingCardIcon.shoppingCardIconBadge) {
    position: relative;
    color: ${colors.white};
  }

  :global(.shoppingCardIcon[data-badge]:after) {
    content: attr(data-badge);
    position: absolute;
    top: -0.25rem;
    right: -0.25rem;
    font: ${fonts.semiBold};
    font-size: ${fontSizes.tiny};
    background: ${colors.badge};
    color: white;
    width: 0.75rem;
    height: 0.75rem;
    text-align: center;
    line-height: 12px;
    border-radius: 50%;
    padding: 1px;
  }

  :global(i.shoppingCardIcon.shoppingCardIconBadge.disabled) {
    color: ${colors.gray};
    cursor: not-allowed;
  }
`
